<template>
  <div>
    <BnpNotification />
  </div>
</template>
<script>
window["kpmg-notification"] =  window['kpmg-notification']  ||  {}
export default {
  name: "AddBnpNotification",
  components: {
    ...window["kpmg-notification"].default
  },
  data: () => ({
    language: ""
  }),
  mounted() {
    this.language = localStorage.getItem("UserLang")
      ? localStorage.getItem("UserLang")
      : this.$i18n.locale;
  }
};
</script>
